import { HackleUser, IdentifiersBuilder, IdentifierType, User } from "../../core/internal/model/model"
import ObjectUtil from "../../core/internal/util/ObjectUtil"

export class HackleUserResolver {
  resolveOrNull(input?: User | string): HackleUser | undefined {
    if (ObjectUtil.isNullOrUndefined(input)) {
      return undefined
    }

    const user = this._resolveUser(input)
    return this._resolveHackleUserOrNull(user)
  }

  _resolveUser(input: User | string): User {
    if (typeof input === "string") {
      return { id: input }
    } else {
      return input
    }
  }

  _resolveHackleUserOrNull(user: User): HackleUser | undefined {
    const builder = new IdentifiersBuilder()
    builder.addIdentifiers(user.identifiers || {})
    if (user.id) {
      builder.add(IdentifierType.ID, user.id)
    }
    if (user.userId) {
      builder.add(IdentifierType.USER, user.userId)
    }
    if (user.deviceId) {
      builder.add(IdentifierType.DEVICE, user.deviceId)
    }
    const identifiers = builder.build()

    if (Object.keys(identifiers).length === 0) {
      return undefined
    }

    return {
      identifiers: identifiers,
      properties: user.properties || {},
      hackleProperties: {}
    }
  }
}
